export default __webpack_public_path__ + "static/media/p8.4b262266.jpg";